const Contact = () => {
  return (
    <div>
      <div className="shell">
        <section
          className="section"
          style={{
            minHeight: 'calc(100vh - 360px)',
            display: 'flex', flexDirection: 'column',
            justifyContent: 'center', alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <div className="divider"><span className="divider-glyph">✦</span></div>

          <h1
            className="display"
            style={{ fontSize: 'clamp(48px, 6vw, 80px)', margin: '28px 0 24px' }}
          >
            Willa dla <em>znajomych</em>.
          </h1>

          <p style={{
            maxWidth: 520, fontSize: 18,
            color: 'var(--ink-soft)', lineHeight: 1.7, margin: 0
          }}>
            Ta strona jest dostępna wyłącznie dla zaproszonych gości.
            Jeśli wiesz, jak do nas dotrzeć — wiesz też jak się skontaktować.
          </p>

          <div className="divider" style={{ marginTop: 48 }}>
            <span className="small-caps olive">— gospodarze</span>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;
